<template>
    <nav class="nav" v-bind:class="{ 'is-expanded' : isNavExpanded }">
        <nav class="nav__switch">
            <a v-bind:class="{ 'is-active' : navActiveTab == 'menu' }" v-on:click="switchNavTab('menu')">{{ __('Menu') }}</a>
            <a v-bind:class="{ 'is-active' : navActiveTab == 'startdesks' }" v-on:click="switchNavTab('startdesks')">{{ __('Startdesks') }}</a>
        </nav>

        <nav class="nav__menu" v-show="navActiveTab == 'menu'">
            <router-link class="nav__menu__item nav__menu__item--home"
                         v-bind:class="{ 'is-active' : $route.name == 'home' || $route.name == 'startdesks.view' }"
                         v-bind:title="__('Home')"
                         v-bind:to="activeStartdesk
                             ? {
                                name: 'startdesks.view',
                                params: { startdesk: activeStartdesk.slug, u: activeStartdesk.is_user_startdesk }
                             }
                             : '/'"
            >
                <span class="jam jam-home"></span>
                {{ __('Home') }}
            </router-link>
            <router-link class="nav__menu__item nav__menu__item--my-day"
                         v-bind:class="{ 'is-active' : $route.name == 'dashboard.index' }"
                         v-bind:title="__('My Day')"
                         v-bind:to="{ name: 'dashboard.index' }"
                         v-if="user"
            >
                <span class="jam jam-calendar-alt"></span>
                {{ __('My Day') }}
            </router-link>
            <router-link class="nav__menu__item nav__menu__item--edit-startdesk"
                         v-bind:class="{ 'is-active' : $route.name == 'startdesks.edit' }"
                         v-bind:title="__('Edit Startdesk')"
                         v-bind:to="{ name: 'startdesks.edit', params: { startdesk: activeStartdesk.id } }"
                         v-if="user && activeStartdesk"
            >
                <span class="jam jam-pencil"></span>
                {{ __('Edit Startdesk') }}
            </router-link>
            <a class="nav__menu__item nav__menu__item--my-startdesks"
               v-bind:class="{ 'is-active' : $route.name == 'startdesks' || $route.name == 'startdesks.categories' }"
               v-if="user && user.is_admin"
            >
                <span class="jam jam-computer-alt"></span>
                {{ __('Startdesks') }}

                <nav>
                    <router-link class="nav__menu__item nav__menu__item--my-startdesks"
                                 v-bind:title="user.is_admin ? __('Manage Startdesks') : __('My Startdesks')"
                                 v-bind:to="{ name: 'startdesks' }"
                                 v-if="user"
                    >
                        <span class="jam jam-computer-alt"></span>
                        {{ user.is_admin ? __('Manage Startdesks') : __('My Startdesks') }}
                    </router-link>
                    <router-link class="nav__menu__item nav__menu__item--startdesk-categories"
                                 v-bind:title="__('Startdesk Categories')"
                                 v-bind:to="{ name: 'startdesks.categories' }"
                                 v-if="user && user.is_admin"
                    >
                        <span class="jam jam-computer-alt-f"></span>
                        {{ __('Startdesk Categories') }}
                    </router-link>
                </nav>
            </a>
            <router-link class="nav__menu__item nav__menu__item--my-startdesks"
                         v-bind:class="{ 'is-active' : $route.name == 'startdesks' }"
                         v-bind:title="user.is_admin ? __('Manage Startdesks') : __('My Startdesks')"
                         v-bind:to="{ name: 'startdesks' }"
                         v-if="user && !user.is_admin"
            >
                <span class="jam jam-computer-alt"></span>
                {{ user.is_admin ? __('Manage Startdesks') : __('My Startdesks') }}
            </router-link>
            <a class="nav__menu__item nav__menu__item--my-startdesks"
               v-bind:class="{ 'is-active' : $route.name == 'tiles' || $route.name == 'tiles.categories' }"
               v-if="user && user.is_admin"
            >
                <span class="jam jam-computer-alt"></span>
                {{ __('Tiles') }}

                <nav>
                    <router-link class="nav__menu__item nav__menu__item--my-tiles"
                                 v-bind:title="user.is_admin ? __('Manage Tiles') : __('My Tiles')"
                                 v-bind:to="{ name: 'tiles' }"
                                 v-if="user && user.is_admin"
                    >
                        <span class="jam jam-chevrons-square-up-right"></span>
                        {{ user.is_admin ? __('Manage Tiles') : __('My Tiles') }}
                    </router-link>
                    <router-link class="nav__menu__item nav__menu__item--tile-categories"
                                 v-bind:title="__('Tile Categories')"
                                 v-bind:to="{ name: 'tiles.categories' }"
                                 v-if="user && user.is_admin"
                    >
                        <span class="jam jam-chevrons-square-up-right-f"></span>
                        {{ __('Tile Categories') }}
                    </router-link>
                </nav>
            </a>
            <a class="nav__menu__item nav__menu__item--my-startdesks"
               v-bind:class="{ 'is-active' : $route.name == 'wallpapers' || $route.name == 'wallpapers.categories' }"
               v-if="user && user.is_admin"
            >
                <span class="jam jam-computer-alt"></span>
                {{ __('Wallpapers') }}

                <nav>
                    <router-link class="nav__menu__item nav__menu__item--wallpapers"
                                 v-bind:title="__('Manage Wallpapers')"
                                 v-bind:to="{ name: 'wallpapers' }"
                                 v-if="user && user.is_admin"
                    >
                        <span class="jam jam-picture"></span>
                        {{ __('Manage Wallpapers') }}
                    </router-link>

                    <router-link class="nav__menu__item nav__menu__item--wallpaper-categories"
                                 v-bind:title="__('Wallpaper Categories')"
                                 v-bind:to="{ name: 'wallpapers.categories' }"
                                 v-if="user && user.is_admin"
                    >
                        <span class="jam jam-picture-f"></span>
                        {{ __('Wallpaper Categories') }}
                    </router-link>
                </nav>
            </a>


            <router-link class="nav__menu__item nav__menu__item--users"
                         v-bind:class="{ 'is-active' : $route.name == 'users' }"
                         v-bind:title="__('Users')"
                         v-bind:to="{ name: 'users' }"
                         v-if="user && user.is_admin"
            >
                <span class="jam jam-users"></span>
                {{ __('Users') }}
            </router-link>
            <router-link class="nav__menu__item nav__menu__item--my-profile"
                         v-bind:title="__('My Profile')"
                         v-bind:to="{ name: 'profile.edit' }"
                         v-if="user"
            >
                <span class="jam jam-user-circle"></span>
                {{ __('My Profile') }}
            </router-link>
            <router-link class="nav__menu__item nav__menu__item--my-profile"
                         v-bind:title="__('Support')"
                         v-bind:to="{ name: 'support' }"
                         v-if="user && !user.is_admin"
            >
                <span class="jam jam-help"></span>
                {{ __('Support') }}
            </router-link>
            <router-link class="nav__menu__item nav__menu__item--login"
                         v-bind:title="__('Login')"
                         v-bind:to="{ name: 'login' }"
                         v-if="!user"
            >
                <span class="jam jam-log-in"></span>
                {{ __('Login') }}
            </router-link>
            <a class="nav__menu__item nav__menu__item--logout"
               v-bind:title="__('Logout')"
               v-if="user"v-on:click="logoutUser"
            >
                <span class="jam jam-log-out"></span>
                {{ __('Logout') }}
            </a>
        </nav>

        <nav class="nav__startdesks" v-show="navActiveTab == 'startdesks'">
            <router-link class="nav__startdesks__item"
               v-bind:class="{ 'is-active' : activeStartdesk && startdesk.id == activeStartdesk.id, 'is-drop-active' : dropActive[startdesk.id] }"
               v-bind:key="startdesk.id"
               v-bind:title="startdesk.name"
               v-bind:to="{
                    name: 'startdesks.view',
                    params: { startdesk: startdesk.slug, u: startdesk.is_user_startdesk }
               }"
               v-for="startdesk in myStartdesks"
               v-if="startdesk.is_visible_to_user"

            >
                <span draggable="true"
                      v-bind:data-id="startdesk.id"
                      v-on="{ drop : handleReorder, dragdrop: handleReorder, dragleave: handleDragLeave, dragover: handleDragOver }"
                      v-on:dragstart="setDragIcon"
                >
                    <span class="nav__startdesks__item__tile-count">{{ startdesk.tiles_count }}</span>
                    <span class="nav__startdesks__item__name">{{ startdesk.name }}</span>
                    <a class="nav__startdesks__item__delete" href="javascript: void(0);"
                       v-if="user"
                       v-on:click.prevent="handleDelete(startdesk)"
                    >
                        <span class="jam jam-close"></span>
                    </a>
                </span>
            </router-link>

            <router-link class="btn is-primary nav__startdesks__btn"
                         v-bind:class="{ 'is-active' : $route.name == 'startdesks.add' }"
                         v-bind:to="{ name: 'startdesks.add', params: { category: (user && user.is_admin) ? 'custom' : null } }"
            >
                <span class="jam jam-plus"></span>
                {{ __('Add Startdesk') }}
            </router-link>
        </nav>

        <div class="nav__lang" style="display:flex; gap:8px; align-items:center; justify-content:center; padding:12px 0 4px;">
            <a v-on:click="setLocale('en')" title="English"
               v-bind:style="{ cursor:'pointer', fontSize:'12px', fontWeight:600, letterSpacing:'.04em', opacity: locale == 'en' ? 1 : .45 }">EN</a>
            <span style="opacity:.3">·</span>
            <a v-on:click="setLocale('hu')" title="Magyar"
               v-bind:style="{ cursor:'pointer', fontSize:'12px', fontWeight:600, letterSpacing:'.04em', opacity: locale == 'hu' ? 1 : .45 }">HU</a>
            <span style="opacity:.3">·</span>
            <a v-on:click="setLocale('de')" title="Deutsch"
               v-bind:style="{ cursor:'pointer', fontSize:'12px', fontWeight:600, letterSpacing:'.04em', opacity: locale == 'de' ? 1 : .45 }">DE</a>
        </div>

        <a class="nav__toggle" v-on:click="toggleNav">
            <span class="jam jam-chevrons-right" v-show="!isNavExpanded"></span>
            <span class="jam jam-chevrons-left" v-show="isNavExpanded"></span>
        </a>
    </nav>
</template>

<script>
    import { eventBus } from '../eventBus.js';
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        data: function () {
            return {
                browser: '',
                dropActive: []
            }
        },
        methods: {
            handleDelete: function (startdesk) {
                eventBus.$emit('show-loader');

                this.$http.delete(this.apiUrl + '/startdesks/' + startdesk.id).then(function (response) {
                    const startdesks = this.myStartdesks.filter(function (myStartdesk) {
                        return myStartdesk.id != startdesk.id
                    }.bind(startdesk));

                    this.updateStartdesks(startdesks);

                    if (startdesk.id == this.activeStartdesk.id) {
                        if (startdesks.length > 0) {
                            this.changeStartdesk(startdesks[0]);
                        } else {
                            this.changeStartdesk(null);
                        }
                    }

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors sending data to server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleDragLeave: function(event) {
                this.$set(this.dropActive, event.currentTarget.dataset.id, false);
                event.preventDefault();
            },
            handleDragOver: function(event) {
                this.$set(this.dropActive, event.currentTarget.dataset.id, true);
                event.preventDefault();
            },
            handleReorder: function(event) {
                this.$set(this.dropActive, event.currentTarget.dataset.id, false);

                const dragged = event.dataTransfer.getData('text');
                const target = event.currentTarget.dataset.id;

                if (dragged != target) {

                    var sortedStartdesks = [];
                    var draggedStartdesk = null;

                    for (var i = 0; i < this.myStartdesks.length; i++) {
                        if (dragged == this.myStartdesks[i].id) {
                            draggedStartdesk = this.myStartdesks[i];
                            break;
                        }
                    }

                    this.myStartdesks.forEach(function (startdesk) {
                        if (dragged != startdesk.id) {
                            if (target == startdesk.id) {
                                sortedStartdesks.push(draggedStartdesk);
                            }

                            sortedStartdesks.push(startdesk);
                        }
                    });

                    this.updateStartdesks(sortedStartdesks);
                    this.$http.patch(this.apiUrl +  '/startdesks/reorder', {
                        startdesks: sortedStartdesks
                    });
                }


                //this.$parent.handleReorder(id, this.startdesk.id);
            },
            init: function () {
                if ((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
                    this.browser = 'opera';
                } else if (typeof InstallTrigger !== 'undefined') {
                    this.browser = 'firefox';
                } else if (/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))) {
                    this.browser = 'safari';
                } else if (/*@cc_on!@*/false || !!document.documentMode) {
                    this.browser = 'ie';
                } else if (!!window.StyleMedia) {
                    this.browser = 'edge';
                } else if (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) {
                    this.browser = 'chrome';
                }
            },
            setDragIcon: function (event) {
                event.stopPropagation();

                const el = event.currentTarget;

                event.dataTransfer.setData('text/plain', el.dataset.id);
                event.dataTransfer.setDragImage(el, 10, 10);
            }
        },
        mixins: [
            clickaway
        ],
        mounted: function () {
            this.init();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Navigation.vue